import { EBEPaymentMethodsName, EPaymentProvider, PaymentMethod } from '../contracts';

const paymentMethodNameToStripePaymentMethodTypesMap: Record<string, string[]> = {
  [EBEPaymentMethodsName.card]: [EBEPaymentMethodsName.card],
  [EBEPaymentMethodsName.blikCheckout]: [EBEPaymentMethodsName.card],
  [EBEPaymentMethodsName.link]: [EBEPaymentMethodsName.card],
};

export function getStripePaymentMethodTypesFromApm(paymentMethod: PaymentMethod) {
  if (paymentMethod.provider !== EPaymentProvider.stripe) {
    return [];
  }
  const paymentMethodTypes =
    paymentMethodNameToStripePaymentMethodTypesMap[paymentMethod.paymentMethodName];

  return paymentMethodTypes || [paymentMethod.pspPaymentMethodName];
}
